import { Component, OnInit, Input, ViewChild, ElementRef, ViewChildren, AfterViewInit, ViewEncapsulation, QueryList } from '@angular/core';
import { IStoreMenuCategoryItem, StoreService, IStoreMenuItem, ITranslatableText, IStore} from 'src/app/store/services/store.service';
import { AlertController, IonContent } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { LoaderService } from '../../services/loader.service';
import { Router } from '@angular/router';
import { AddressEditorModalComponent } from '../../components/address-editor-modal/address-editor-modal.component';
import { GoogleApiService } from 'src/app/shared/services/google-api.service';
import { GeolocationHelpers } from 'src/app/helpers/geolocataion-helpers';
import { IGeopoint, OrderType } from 'src/app/store/pages/list-page/list-page.component';
import { Storage } from '@ionic/storage';
import { ITenantConfiguration, SettingService } from '../../services/setting.service';
import { IAddress } from '../../services/address.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertService } from '../../services/alert.service';
import { IItemDetailCombination, IOrder, IOrderItem } from 'src/app/store/services/order.service';
import { TranslationService } from '../../services/translation.service';
import { ItemContentDetailsModalComponent } from '../item-content-details-modal/item-content-details-modal.component';

@Component({
  selector: 'app-menu-item-allinone-modal',
  templateUrl: './menu-item-allinone-modal.component.html',
  styleUrls: ['./menu-item-allinone-modal.component.scss'],
  standalone: false
})
export class MenuItemAllinoneModalComponent implements OnInit, AfterViewInit {
  @Input() item: IStoreMenuCategoryItem;
  @Input() store: IStore;
  @Input() orderType: OrderType;
  @Input() chosenQuantity: number;
  @Input() chosenItemDetailCombination: IItemDetailCombination;
  @Input() dismissItemModal;
  @Input() trackStoreId: string; // mainly used for starting new orders if its not the same store

  @Input() orderItem: IOrderItem; // mainly used for starting new orders if its not the same store
  @Input() order: IOrder; // mainly used for starting new orders if its not the same store

  @Input() orderItemEditing?: IOrderItem;

  cartOrderType: OrderType;

  //itemDetailCombination: itemDetailCombination; // this is for retail items (invalid for this version)
  deliveryAddress: IAddress;
  newOrder: boolean = false;
  isAlcohol: boolean = false;
  selectedOrderType: OrderType;
  normalPrice: number;
  
  selectedQuantity: number = 1;
  itemQuantity?: number;

  postError: boolean = false;

  itemsImgSrc: any = null;
  isFavorite: boolean = false;

  itemPrice: number;

  
  selectedSubItem: any;
  selectedSubItemIndex: number = 0;
  optionsImgs: any = [];
  gotoOptions: boolean = false;
  optionGroupIndex: number = 0;
  optionOnCurrentSelection: boolean = false;
  seeOptions: boolean = false;

  buynow: boolean;

  homersLayout: boolean = false;

  @ViewChild('detailsContent') detailsContent!: ElementRef<HTMLDivElement>;
  isExpanded = false;
  currentHeight = 0;
  collapsedHeight = 0;

  @ViewChild(IonContent) content!: IonContent;
  @ViewChild('optionsSection') optionsSection!: ElementRef;
  @ViewChildren('optionGroup') optionGroups!: QueryList<ElementRef>;

  constructor(private modalCtrl: ModalController,
    private router: Router,
    private storage: Storage,
    private loader: LoaderService,
    private storeService: StoreService,
    private alertCtrl: AlertController,
    public settingService: SettingService,
    private googleApiService: GoogleApiService,
    private alertService: AlertService,
    public sanitizer: DomSanitizer,
    public translationService: TranslationService,
    private element: ElementRef
  ) { }

  
  private _geopoint: IGeopoint;
  get geopoint(): IGeopoint {
    return this._geopoint;
  }

  set geopoint(value: IGeopoint) {
    this._geopoint = value;
    if (!value)
      return;

    this.store._distance = GeolocationHelpers.distance(value.latitude, value.longitude, this.store.address.latitude, this.store.address.longitude);
  }

  ngOnInit() {    
    console.log(this.item);
    console.log(this.store);
    console.log(this.orderType);
    console.log(this.chosenQuantity); // will probably only use for item editing
    console.log(this.chosenItemDetailCombination); // this seems to be for retail items
    console.log(this.dismissItemModal);
    console.log(this.trackStoreId); //this one simply checks if it's the same store as before (used to start a new order)


    console.log(this.orderItemEditing); //if the user edit an order, it pulls the specific order's detail
  

    this.itemPrice = this.item.item.price;
    /*
    if(this.item.item.quantity) {
      this.selectedQuantity = this.item.item.quantity;
    } else {
      this.selectedQuantity = 1;
    }
    */
    
    //preselect the first subItem (may change it)
    if(!this.orderItemEditing) {
      if(this.item.subItems.length > 0) {
        this.subItemSelected(this.item.subItems[0], 0);
      }
    } else {
      if (this.item.subItems.length > 0) {
        if (this.item.subItems.length > 0) {
          const subItemIndex = this.item.subItems.findIndex(
            subItem => subItem.id === this.orderItemEditing.itemId
          );

          if (subItemIndex !== -1) {
            this.subItemSelected(this.item.subItems[subItemIndex], subItemIndex);
          }

          this.seeOptions = true;

          this.preSelectOptions();
        }
      }
    }
    
   


    // this.item is the main thing
    // this.store for some additional details
    // this.orderType for the ordertype obviously (may not have it yet)

    this.getItemImage(this.item.item);
    
    this.normalPrice = this.item.item.price;

    if(this.item.item.isRetailItem) {
      this.cancel();
    }

    if(this.item.item.isInventoryExist)
    {
      if(this.item.item.isInventoryActive)
      {
        this.checkQuantity();
      }
    }

    if (this.settingService.configuration.uIoptions) {
      const hostElement = this.element.nativeElement;

      const host = hostElement;
      if(this.settingService.configuration.uIoptions?.horizontalMenuStartColor && this.settingService.configuration.uIoptions?.horizontalMenuEndColor) {
        host.style.setProperty('--gradient-color-start', this.settingService.configuration.uIoptions?.horizontalMenuStartColor);
        host.style.setProperty('--gradient-color-end', this.settingService.configuration.uIoptions?.horizontalMenuEndColor);
      }
      if(this.settingService.configuration.uIoptions?.mobileCheckoutBottomBarColor && this.settingService.configuration.uIoptions?.mobileTextCheckoutBottomBarColor) {
        host.style.setProperty('--Checkout-Bar-Color', this.settingService.configuration.uIoptions?.mobileCheckoutBottomBarColor);
        host.style.setProperty('--Checkout-Bar-Text-Color', this.settingService.configuration.uIoptions?.mobileTextCheckoutBottomBarColor);
      }
    }

    if(this.settingService.configuration.uIoptions && this.settingService.configuration.homePageConfiguration != null && this.settingService.configuration.uIoptions?.homePageOption == 10) {
      this.homersLayout = true;
    } else {
      this.homersLayout = false;
    }
    
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if(this.chosenQuantity){
        this.selectedQuantity = this.chosenQuantity;
      }
    });

    // Height of exactly 3 lines
    const lineHeight = parseFloat(
      getComputedStyle(this.detailsContent.nativeElement).lineHeight
    );

    this.collapsedHeight = lineHeight * 3;
    this.currentHeight = this.collapsedHeight;
  }

  selectedOption(itemOption) {
    console.log(itemOption);
  }

  async nextOptionGroup(cat, index, isOrderComplete) {
    console.log(cat);

    //i'll process this in 2 ways. 1 we continu to the next group, 2 we trigger the order complete
    // first i need to confirm that the options are properly selected

    var validatedSelection = this.confirmSelection(cat, index);

    if(validatedSelection) {
      if(isOrderComplete) {
        this.completeItemOptions();


      } else {
        this.optionGroupIndex++;

        // to automatically scroll to the next options
        await new Promise(resolve => setTimeout(resolve, 100));

        const groups = this.optionGroups.toArray();

        const target =
          groups[groups.length - 1];

        if (target) {

          const y =
            target.nativeElement.offsetTop - 20;

          await this.content.scrollToPoint(
            0,
            y,
            600
          );
        }
      }
    }
    

    
  }

  disableAddOption(): boolean {

    //{{{{ this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit != null ? this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit : this.selectedSubItem.itemOptionCategories[optionGroupIndex].options.length}} {{'complete item order'}} 


    if(this.selectedSubItem?.itemOptionCategories) {

      var quantity = this.getOptionsQty(this.selectedSubItem.itemOptionCategories[this.optionGroupIndex]);
        //this.selectedSubItem.itemOptionCategories[optionGroupIndex].multipleLimit != null
      if(this.selectedSubItem.itemOptionCategories[this.optionGroupIndex].multipleLimit != null) {
        if(quantity < this.selectedSubItem.itemOptionCategories[this.optionGroupIndex].multipleLimit || quantity > this.selectedSubItem.itemOptionCategories[this.optionGroupIndex].multipleLimit) {
          return true;
        }
      }
      

      /*
      for(var i = 0; i < this.selectedSubItem?.itemOptionCategories?.length; i++) {
        var itemOptionCat = this.selectedSubItem.itemOptionCategories[i];

        if(itemOptionCat.isMultiple && itemOptionCat.multipleLimit) {
          var counter = 0;
          for(var y = 0; y < itemOptionCat?.options.length; y++) {
            var itemOption = itemOptionCat?.options[y];

            if(itemOption?.quantity > 0) {
              counter += itemOption.quantity;
            }
          }

          console.log(counter);
          if(counter < itemOptionCat.multipleLimit || counter > itemOptionCat.multipleLimit) {
            return true;
          }
        }

        if(itemOptionCat.isOptionnal) {
          //return false;
          continue;
        }
      }
      */
    }
    return false;
  }

  confirmSelection(cat, index): boolean {

    if(!cat.isOptionnal) {
      if(cat.isMultiple == false) {
        var addedVal = 0;
        for(var i = 0; i < cat.options.length; i++) {
          var option = cat.options[i];
          if(option.option.quantity > 0) {
            addedVal++;
          }
        }

        if(addedVal > 0) {
          return true;
        }

        
      } else if(cat.isMultipleUnlimited == false && cat.isMultiple) {
        var addedVal = 0;
        var limit = 0;
        if(cat.multipleLimit) {
          limit = cat.multipleLimit;
        } else {
          limit = cat.options.length;
        }
        
        for(var i = 0; i < cat.options.length; i++) {
          var option = cat.options[i];
          if(option.option.quantity > 0) {
            addedVal++;
          }
        }

        if(addedVal <= limit) {
          return true;
        }
      } else if(cat.isMultiple && cat.isMultipleUnlimited) {
        var addedVal = 0;

        for(var i = 0; i < cat.options.length; i++) {
          var option = cat.options[i];
          if(option.option.quantity > 0) {
            addedVal++;
          }
        }

        if(addedVal > 0) {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
    
    
    /*
    @if (itemOptionsCat.isMultiple == false) {
                            <button class="Item-number-Next">{{(itemOptionsCat?.options.length == 0 ? 'Choice.Select' : 'Choice.Selected') | translate}}: {{getOptionsQty(itemOptionsCat)}} / 1</button>
                          }

                          @if (itemOptionsCat.isMultipleUnlimited == false && itemOptionsCat.isMultiple) {
                            <button class="Item-number-Next">{{(itemOptionsCat.options.length == 0 ? 'Choice.Select' : 'Choice.Selected') | translate }}: {{getOptionsQty(itemOptionsCat)}} / {{ itemOptionsCat.multipleLimit != null ? itemOptionsCat.multipleLimit : itemOptionsCat.options.length}}</button>
                          }

                          @if (itemOptionsCat.isMultiple && itemOptionsCat.isMultipleUnlimited) {
                            <button class="Item-number-Next">{{ 'Choice.SelectUnlimited' | translate }}</button>
                          }
    */
    return false;
  }

  getOptionsQty(itemOptionsCat) {
    var optionSelected = 0;
    var quantity = 0;
    for(var i = 0; i < itemOptionsCat.options.length; i++) {
      var option = itemOptionsCat.options[i];

      if(option.option.quantity > 0) {
        optionSelected++;

        quantity += option.option.quantity;
      }
    }

    //return optionSelected;
    return quantity;
  }

  backOption() {
    if(this.optionGroupIndex == 0) {
      this.viewingOptions();
    } else {
      this.optionGroupIndex--;
    }
  }

  completeItemOptions() {
    console.log("completed order");

    this.onStartOrder();
  }

  nameDisplayed(item): string {
    // confirms that the item name exists
    var itemName = "";
    if(item.itemName) {
      if(item.itemName.translations[this.translationService.getLanguage()]) {
        itemName = item.itemName.translations[this.translationService.getLanguage()];
      } else {
        itemName = "";
      }
    }
    
    // check if the name is overwriten
    if(item.nameOverwrite?.translations[this.translationService.getLanguage()]) {
      if(item.nameOverwrite.translations[this.translationService.getLanguage()]) {
        return item.nameOverwrite.translations[this.translationService.getLanguage()];
      } else {
        return itemName;
      }
    } else {
      return itemName;
    }
  }

  subItemSelected(subItem, subitemIndex) {
    console.log("clicked subitem");
    // you'll edit the price here

    this.selectedSubItem = subItem;
    this.selectedSubItemIndex = subitemIndex;


    console.log(subItem);
    this.itemPrice = subItem.price;


    this.seeOptions = false;
    this.optionGroupIndex = 0;
  }

  preSelectOptions(){

    //itemOption: any, value: number, category: any
    for(var i = 0; i < this.selectedSubItem.itemOptionCategories.length; i++) {
      var itemOptionsCat = this.selectedSubItem.itemOptionCategories[i];

      for(var y = 0; y < itemOptionsCat.options.length; y++) {
        var itemOption = itemOptionsCat.options[y];

        const matchingOption = this.orderItemEditing.options.find( orderOption => orderOption.itemId === itemOption.itemId );

        if (matchingOption) { 
          itemOption.option.quantity = matchingOption.quantity; 
        }
      }
    }
    this.changeOptionQuantity(itemOption, -1, itemOptionsCat);


    
  }

  optionSelected(optionCat, option) {
    console.log("clicked Option");
    // you'll edit the price here

    // we'll track the option category and the specific option in there that is selected for full context
    console.log(optionCat);

    console.log(option) // option is the same as this.item.item.itemOptionCategories[0].options[0].option
    //this.item.item.itemOptionCategories[0].options[0].option.price
  }

  changeQuantity(value) {
    this.selectedQuantity = this.selectedQuantity + value;
    if(this.selectedQuantity < 1) {
      this.selectedQuantity = 1;
    }
  }

  getItemImage(item) {
    if ( item.itemImageShortName != "" && item.itemImageShortName != null) {
      this.itemsImgSrc = this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + item.itemImageShortName);
    } else {
      this.itemsImgSrc = null;
    }
  }

  onHeartClick() {
    
  }


  toggleReadMore() {
    //this.isExpanded = !this.isExpanded;

    if (!this.isExpanded) {
      // EXPAND
      this.isExpanded = true;

      requestAnimationFrame(() => {
        this.currentHeight =
          this.detailsContent.nativeElement.scrollHeight + 40; // icons space
      });
    } else {
      // COLLAPSE
      this.currentHeight = this.collapsedHeight;

      // wait for animation to finish before clamping text
      setTimeout(() => {
        this.isExpanded = false;
      }, 350);
    }

    console.log("read more triggered");
  }

  checkQuantity(item = null) {   
    let storage = JSON.parse(localStorage.getItem('cartStorage'));
 
    if(storage)
    {  
      let quantity = 0;

      let result = this.item.item.quantity;
      storage.map(item => {
        if(this.item.itemId == item.itemId)
          {         
            quantity += item.quantity;                  
          }
      });
      this.itemQuantity = result - quantity;
      
    }
    else 
    {
      this.itemQuantity = item.quantity;
    }
      
  }

  textDisplay(text, lang) {
    const fallbackLang = lang === 'en' ? 'fr' : 'en';

    return text.translations[lang] ?? text.translations[fallbackLang];
  }

  noQty() {
    this.alertCtrl.create({
      header: this.translationService.translate('Menu.OutOfStockTitle'),
      message: this.translationService.translate('Menu.OutOfStock'),
      buttons: [
        {
          text: 'Okay',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            
          }
        }
      ]
    }).then(al=>{
      al.present();
    });
  }

  // this seems to be where the order is sent. i'll have to edit this
  onStartOrder(buynow?: boolean, orderType = this.orderType) {

    if(buynow) {
      this.buynow = buynow;
    }else {
      this.buynow = false;
    }
    
    
    if(!this.orderType){
      this.storage.set('orderType',orderType);
      this.router.navigateByUrl('/stores')
      this.cancel();
      return
    }

    if(this.itemQuantity == 0 && this.item.item.isInventoryExist)
    {
      this.noQty();
      return;
    }

    if(this.selectedQuantity > this.itemQuantity)
    {
      this.noQty();
      return;
    }

    if(orderType == "delivery") {
      if(localStorage.getItem("deliveryAddress") == null){
        this.cartOrderType = orderType;
        this.chooseAddress();
        return;
      }
    } else if (orderType == "shipping"){
      if(localStorage.getItem("shippingAddress") == null){
        this.cartOrderType = orderType;
        this.chooseAddress();
        return;
      }
    }


    // !!!!!!!!!!! warning! for some reason, the console logs is not able to keep up with the value update. so the options[x].option.quantity is properly being updated but it won't show it
    if(this.item.item.isAlcohol && !this.isAlcohol) {
      this.selectedOrderType = orderType;
      this.isAlcohol = true;

    } else if (localStorage['StoreId'] && localStorage['StoreId'] !== this.trackStoreId) {

      
      console.log("new cart");
      /*
      this.newOrder = true;
      this.cartOrderType = orderType;
      */

      this.modalCtrl.dismiss({
        cancel: false,
        //itemDetailCombination: this.item.item.isRetailItem ? this.itemDetailCombination : null,
        itemDetailCombination: null, // not dealing with retail on this template
        quantity: 0,
        foodQuantity: this.selectedQuantity,
        item: this.item,
        selectedSubItem: this.selectedSubItem,
        combinationPrice: null, // retail option not handled
        orderType: orderType,
        buynow: buynow
      });

    } else {
      // added a value where we return the sub item selected as well

      this.modalCtrl.dismiss({
        cancel: false,
        //itemDetailCombination: this.item.item.isRetailItem ? this.itemDetailCombination : null,
        itemDetailCombination: null, // not dealing with retail on this template
        quantity: 0,
        foodQuantity: this.selectedQuantity,
        item: this.item,
        selectedSubItem: this.selectedSubItem,
        combinationPrice: null, // retail option not handled
        orderType: orderType,
        buynow: buynow
      });
    }
  }
  
  cancel() {
    this.modalCtrl.dismiss({
      cancel: true
    });
    localStorage.removeItem('editKey');
  }

  emptyCart() {
    localStorage.removeItem("TimeLimit");
    localStorage.removeItem("cartStorage");
    localStorage.removeItem("StoreId");
    this.newOrder = false;
    this.modalCtrl.dismiss({
      cancel: false,
      emptyCart: true,
      //itemDetailCombination: this.item.item.isRetailItem ? this.itemDetailCombination : null,
      itemDetailCombination: null, // not dealing with retail in on this version
      quantity: 0,
      foodQuantity: this.selectedQuantity,
      item: this.item,
      combinationPrice: null, // retail option not handled
      orderType: this.cartOrderType,
      buynow: this.buynow
    }); 
  }

  track(e: Event) {
    const target = e.target as HTMLInputElement;

    if(target.className == "modal-new-cart" || target.id == "no")
    {
      this.newOrder = false;
    }
  } 

  async chooseAddress() {
    const modal = await this.modalCtrl.create({
      component: AddressEditorModalComponent,
      componentProps: {
        title: 'Store.Address',
        skipProvinceValidation: true
      },
      cssClass: 'custom-border-modal-css'
    })

    modal.onWillDismiss()
    .then(async (result) => {
      if (result.data) { 
        let address = result.data;
        this.googleApiService.getAddressGeometry(address).subscribe((result) => {
          this.geopoint = {
            latitude: result.lat,
            longitude: result.lng
          }

          this.googleApiService.getCountry(this.geopoint).subscribe((country) => {
            address.country = country;
            if(this.cartOrderType == "delivery"){
              // validate address
              let isAddressValid = false;
              if (this.store.postalCodesDelivery && this.store.postalCodesDelivery.length > 0) {
                let found = this.store.postalCodesDelivery.indexOf(address.postalCode) > -1;
                if (found) {
                  isAddressValid = found;
                }
              }
              if(!isAddressValid && this.store.deliveryZone && this.store.deliveryZone.deliveryZone != null && this.store.deliveryZone.deliveryZone.length > 0){
                // need to find a point for the current address to compare with the points
                let found = false;
                this.store.deliveryZone.deliveryZone.forEach(zone => {
                  if(this.storeService.inside(this.geopoint, zone.points)){
                    found = true;
                  }
                });
                isAddressValid = found;
              }
              // the radius is only taken in reference when no postal code are supplied
              // || ( store.isDoorDashDrive &&  this.orderType =="delivery" && store._distance <=  this.doorDashDriveAverageRadius)
              if (!isAddressValid && this.store._distance <= this.store.deliveryRadius ) {
                isAddressValid = true;
              }
              if(!isAddressValid){
                this.alertService.showTranslate('Address.InvalidAddress');
                return;
              }
            }
            if(this.cartOrderType == "delivery"){
              localStorage.setItem("deliveryAddress", JSON.stringify(address));
            } else if (this.cartOrderType == "shipping") {
              localStorage.setItem("shippingAddress", JSON.stringify(address));
            }
            this.dismissItemModal(false, null, 
              this.selectedQuantity, this.item, null, this.cartOrderType);
          });
        });
      }
    });

    await modal.present();
  }

  isAddressValid(address: IAddress): boolean {
    if(address) {
      this.googleApiService.getAddressGeometry(address).subscribe((result) => {
        this.geopoint = {
          latitude: result.lat,
          longitude: result.lng
        }
  
        if (this.store.postalCodesDelivery && this.store.postalCodesDelivery.length > 0) {
          let found = this.store.postalCodesDelivery.indexOf(address.postalCode) > -1;
          if (found) {
            return found;
          }
        }
    
        if(this.store.deliveryZone && this.store.deliveryZone.deliveryZone != null && this.store.deliveryZone.deliveryZone.length > 0){
          // need to find a point for the current address to compare with the points
          let found = false;
          this.store.deliveryZone.deliveryZone.forEach(zone => {
            if(this.storeService.inside(this.geopoint, zone.points)){
              found = true;
            }
          });
    
          return found;
        }
    
        // the radius is only taken in reference when no postal code are supplied
        // || ( store.isDoorDashDrive &&  this.orderType =="delivery" && store._distance <=  this.doorDashDriveAverageRadius)
        if (this.store._distance <= this.store.deliveryRadius ) {
          return true;
        }
        return false;
      });
    } else {
      return false;
    } 
  }

  async openItemContentDetails(contentType: string) {
    const modal = await this.modalCtrl.create({
      component: ItemContentDetailsModalComponent,
      componentProps: {
        contentDisplayType: contentType, // here it could be "all, nutrition, allergen and flavor"
        ItemId: this.item.itemId
      },
      cssClass: 'item-content-detail-modal-css'
    })

    modal.onWillDismiss()
    .then(async (result) => {
      if (result.data) { 
        
      }
    });

    await modal.present();
  }

  // for read more
  wordStripping() {

  }

  getOptionsItemImage(option) {
    if(option.option.imageShortName) {
      return this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + option.option.imageShortName);
    } else {
      return null
    }
   
  }

  hideImage(event: any) {
    event.target.style.display = 'none';
  }

  changeOptionQuantity(itemOption: any, value: number, category: any) {
    console.log(itemOption);

    // !!!!!!!!!!! warning! for some reason, the console logs is not able to keep up with the value update. so the options[x].option.quantity is properly being updated but it won't show it
    if(!category.isMultiple) {
      if(itemOption.option.quantity > 0) {
        return;
      } else {
        for(var i = 0; i < category.options.length; i++) {
          var catoption = category.options[i];

          if(catoption.option.quantity > 0) {
            catoption.option.quantity = 0;

            catoption.isAnimating = false;

            setTimeout(() => {

              catoption.isAnimating = true;

              // FORCE angular refresh
              this.selectedSubItem = {
                ...this.selectedSubItem
              };

              setTimeout(() => {
                catoption.isAnimating = false;

                // FORCE angular refresh again
                this.selectedSubItem = {
                  ...this.selectedSubItem
                };

              }, 500);

            });
          }
        }

        itemOption.option.quantity = (itemOption.option.quantity || 0) + value;

        if (itemOption.option.quantity < 0) {
          itemOption.option.quantity = 0;
        }

        // animation trigger
        itemOption.isAnimating = false;

        setTimeout(() => {

          itemOption.isAnimating = true;

          // FORCE angular refresh
          this.selectedSubItem = {
            ...this.selectedSubItem
          };

          setTimeout(() => {
            itemOption.isAnimating = false;

            // FORCE angular refresh again
            this.selectedSubItem = {
              ...this.selectedSubItem
            };

          }, 500);

        });
      }
      
    } else if(!category.isMultipleUnlimited) {
      if (this.getOptionsQty(category) >= category.multipleLimit && value > 0) {
        return;
      } else {
        itemOption.option.quantity = (itemOption.option.quantity || 0) + value;

        if (itemOption.option.quantity < 0) {
          itemOption.option.quantity = 0;
        }

        // animation trigger
        itemOption.isAnimating = false;

        setTimeout(() => {

          itemOption.isAnimating = true;

          // FORCE angular refresh
          this.selectedSubItem = {
            ...this.selectedSubItem
          };

          setTimeout(() => {
            itemOption.isAnimating = false;

            // FORCE angular refresh again
            this.selectedSubItem = {
              ...this.selectedSubItem
            };

          }, 500);

        });
      }
    } else {
      itemOption.option.quantity = (itemOption.option.quantity || 0) + value;

      if (itemOption.option.quantity < 0) {
        itemOption.option.quantity = 0;
      }

      // animation trigger
      itemOption.isAnimating = false;

      setTimeout(() => {

        itemOption.isAnimating = true;

        // FORCE angular refresh
        this.selectedSubItem = {
          ...this.selectedSubItem
        };

        setTimeout(() => {
          itemOption.isAnimating = false;

          // FORCE angular refresh again
          this.selectedSubItem = {
            ...this.selectedSubItem
          };

        }, 500);

      });
    }
    

    //console.log('UPDATED', itemOption.option.quantity);

    // FORCE angular refresh
    this.selectedSubItem = {
      ...this.selectedSubItem
    };
  }

  currentItemOptionQuantity(itemOption): number {
    if(!itemOption.option.quantity) {
      itemOption.option.quantity = 0;
    }
    return itemOption.option.quantity;
  }

  viewingOptions() {
    if(!this.seeOptions) {
      this.gotoOptions = !this.gotoOptions;

      this.seeOptions = true;

      this.gotoOptionsSection();
    }
    
  }

  async gotoOptionsSection() {

    await new Promise(resolve => setTimeout(resolve, 50));
    const y =
      this.optionsSection.nativeElement.offsetTop;

    this.content.scrollToPoint(0, y, 500);
  }
}